/**
 * 日期提醒tap切换
 * created by lzy 2020.03.23
 */

'use strict';
angular.module('dateReminderTapModule', []).directive('dateReminderTap', ['messagePublishService',
    function(messagePublishService) {
        return {
            restrict: 'E',
            repalace: false,
            scope: {
                callback: '&',
                taps: '=',
                selectType: '='
            },
            templateUrl: './dateReminder/directive/topTap/topTap.html',
            link: function($scope) {
                initStatus();
                initData();
                
                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.data = {};
                }

                /**
                 * [initData description] 初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    $scope.selectType = $scope.selectType || '';
                }

                /**
                 * [selectTap description] 点击tap切换页事件
                 *
                 * @param   {[type]}  type  [type description] 选中哪一项
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.selectTap = function(type) {
                    if (type !== $scope.selectType) {
                        $scope.selectType = type;
                        $scope.callback()(type);
                    }
                };
            }
        };
    }
]);
